module.exports = __webpack_public_path__ + "static/media/pointsYellow.4442d36b.svg";